import React, { PropsWithChildren } from 'react';
import MultiSelectionProvider from 'components/v2/MultiSelections/MultiSelectionsProvider';
import Icon from '../../../components/v2/Icon/Icon';
import { useTranslation } from 'utils/translation';
import { applyFilters } from '../../../core';
import AppFilters from '../../../core/filters';
import { Dir } from '../../dirs';
import useMultipleDirectoryFieldsForm from '../../intelligent-layer/hooks/useMultipleDirectoryFieldsForm';
import { useAppFeatures } from '../../ui/selectors/app';
import usePermissions from '../../auth/permissions';

type ReportMultiSelectionProviderProps = PropsWithChildren<{
  id?: string;
}>;

const ReportMultiSelectionProvider = ({
  children,
  id,
}: ReportMultiSelectionProviderProps) => {
  const { t } = useTranslation();
  const features = useAppFeatures();
  const { can } = usePermissions();
  const hasBulkUpdate = features['assets.list.bulk_update'] ?? false;

  const openMultipleFieldsFormModal = useMultipleDirectoryFieldsForm();
  const openMultipleFieldsForm = (
    selection: { id: string | number; type: string }[],
  ) => {
    const dirs = selection as unknown as Dir[];
    openMultipleFieldsFormModal(dirs);
  };

  const defaultMultiActions = [];

  if (hasBulkUpdate && can('update directory fields')) {
    defaultMultiActions.push({
      label: t('Edit'),
      icon: <Icon name="fa-regular fa-pencil" />,
      action: openMultipleFieldsForm,
    });
  }

  const multiActions = applyFilters(
    AppFilters.reports.multiActions,
    defaultMultiActions,
    {
      id,
    },
  );

  return (
    <MultiSelectionProvider actions={multiActions}>
      {children}
    </MultiSelectionProvider>
  );
};

export default ReportMultiSelectionProvider;
